import {Component, Input} from '@angular/core';
import {YuColorDto} from 'yukit';

@Component({
  selector: 'app-transfer-data',
  templateUrl: './transfer-data.component.html',
  styleUrls: ['./transfer-data.component.scss'],
  standalone: false
})
export class TransferDataComponent {
  @Input() reference!: string;
  @Input() date!: string | number | Date;
  @Input() location!: string;
  @Input() user!: string;
  @Input() state!: string;
  @Input() colorState!: YuColorDto;
}
